export default function(routes, backNum, child) {
  const currentRoutes = routes,
        len = currentRoutes.length - (backNum || 0);
  let newRoute = "";

  for(let i=1; i < len; i++) {
    if(currentRoutes[i].path) newRoute += `/${currentRoutes[i].path}`;
  }

  if(child) newRoute += `/${child}`;
    
  return newRoute;
}


// WEBPACK FOOTER //
// ./src/commonJS/getRoute.js